import '../../../../App.css';
import { Menu, MenuItem } from '@mui/material';
import CreateDiscussionWidget from '../../discussions/CreateDiscussionWidget';
import CreateCommunityWidget from '../../Communities/CreateCommunityWidget';
import AddCommunityMemberWidget from '../../Communities/AddCommunityMemberWidget';

const MobileLoggedInHeader = ({ anchorEl, handleCloseMenu, isLoggedIn, setIsLoggedIn }) => {


  return (
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && anchorEl.id === 'hamburger-menu'}
              onClose={handleCloseMenu}
            >
              {/* Update these to trigger the Widget's internal open state */}
              {!isLoggedIn ? [
                
              ] : [
                <MenuItem key="createDiscussion">
                  <CreateDiscussionWidget isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} closeMenu={handleCloseMenu} />
                </MenuItem>,
                <MenuItem key="createCommunity">
                  <CreateCommunityWidget isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} closeMenu={handleCloseMenu} />
                </MenuItem>,
                <MenuItem key="addCommunityMember">
                  <AddCommunityMemberWidget isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} closeMenu={handleCloseMenu} />
                </MenuItem>
              ]
              }
            </Menu>
  )
};

export default MobileLoggedInHeader;